import { format } from 'date-fns';
import i18next from 'i18next';
import { LogsListItem } from 'entities/Logs/logsTypes';
import { StatusBadge } from 'shared/ui/StatusBadge/StatusBadge';
import { Column } from 'shared/ui/tables/_common/types';
import { TableTranslationLabel } from 'shared/ui/tables/_common/ui/TableTranslationLabel';

export type ExportErrorRow = LogsListItem & { id: string };

export const ExportErrorsColumns: Array<Column<ExportErrorRow>> = [
	{
		field: 'createdAt',
		commonCellSettings: { style: { width: '18%' } },
		headerCellSettings: {
			renderCell: () => <TableTranslationLabel path="integrations.export_errors.columns.date" />,
		},
		bodyCellSettings: {
			prepareField: (row) =>
				row?.createdAt ? format(new Date(row.createdAt), 'dd/MM/yyyy HH:mm') : '-',
		},
	},
	{
		field: 'fileName',
		commonCellSettings: { style: { width: '27%', wordBreak: 'break-word' } },
		headerCellSettings: {
			renderCell: () => <TableTranslationLabel path="integrations.export_errors.columns.document" />,
		},
		bodyCellSettings: {
			prepareField: (row) => row?.fileName || '-',
		},
	},
	{
		field: 'outcome',
		commonCellSettings: { style: { width: '20%' } },
		headerCellSettings: {
			renderCell: () => <TableTranslationLabel path="integrations.export_errors.columns.outcome" />,
		},
		bodyCellSettings: {
			renderCell: (row) => (
				<StatusBadge variant={row?.isTerminal === false ? 'warning' : 'error'}>
					{row?.outcome || i18next.t('integrations.export_errors.error')}
				</StatusBadge>
			),
		},
	},
	{
		field: 'errorMessage',
		commonCellSettings: { style: { wordBreak: 'break-word' } },
		headerCellSettings: {
			renderCell: () => (
				<TableTranslationLabel path="integrations.export_errors.columns.error_detail" />
			),
		},
		bodyCellSettings: {
			prepareField: (row) => row?.errorMessage || '-',
		},
	},
];
